
import React from 'react';
import type { SmartColumn, SortState } from './smartTable.types';
interface BodyListProps {
  visibleColumns: SmartColumn[];
  pageData: any[];
  formatValue: (row: any, col: SmartColumn) => React.ReactNode;
  localStartIndex: number;
  sortState: SortState;
  onHeaderSort: (key: string) => void;
}
const SortIcon: React.FC<{dir: 'asc'|'desc'|undefined}> = ({ dir }) => (<span className="st-sort-icon">{dir === 'asc' ? '▲' : dir === 'desc' ? '▼' : '•'}</span>);
const SmartTableBodyList: React.FC<BodyListProps> = ({ visibleColumns, pageData, formatValue, localStartIndex, sortState, onHeaderSort }) => {
  if (pageData.length === 0) return (<div className="st-empty">Sin resultados</div>);
  const headerColsCandidate = visibleColumns.filter((c) => c.def?.header);
  const headerCols = headerColsCandidate.length > 0 ? headerColsCandidate : visibleColumns.slice(0, Math.min(visibleColumns.length, 3));
  const bodyCols = visibleColumns.filter((c) => !headerCols.includes(c));
  return (
    <div className="st-accordion-list">
      <div className="st-list-header">
        <table className="st-table st-table--inline">
          <thead>
            <tr className="st-tr">
              {headerCols.map((c) => {
                const isSortable = c.def.sortable === true;
                const current = sortState.key === c.key ? sortState.direction : undefined;
                return (
                  <td key={c.key} className="st-th">
                    <span onClick={()=> isSortable && onHeaderSort(c.key)}>{c.label}{isSortable && <SortIcon dir={current} />}</span>
                  </td>
                );
              })}
            </tr>
          </thead>
        </table>
      </div>
      {pageData.map((row, idx) => (
        <div key={idx} className="st-accordion__item">
          <div className="st-accordion__body">
            <table className="st-table st-table--inline">
              <tbody>
                <tr className="st-tr">
                  {headerCols.map((c) => (
                    <td key={c.key} className="st-inline__cell--value">{formatValue(row, c)}</td>
                  ))}
                </tr>
                <tr className="st-tr">
                  {bodyCols.map((c) => (
                    <td key={c.key} className="st-inline__cell--label">{c.label}</td>
                  ))}
                </tr>
                <tr className="st-tr">
                  {bodyCols.map((c) => (
                    <td key={c.key} className="st-inline__cell--value">{formatValue(row, c)}</td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </div>
  );
};
export default SmartTableBodyList;